import React, { Fragment } from "react";
import { Form, Input, Button, InputNumber, DatePicker } from "antd";
import { ReactSVG } from "react-svg";

const SpinGameForm = ({ handleSubmitForm, form, handleCancel, spinGameId }) => {
	return (
		<Fragment>
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Name"
						name="name"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input placeholder="Required" />
					</Form.Item>
					<Form.Item
						label="Total Chances"
						name="total_chances"
						rules={[{ required: true, message: "Required" }]}
					>
						<InputNumber placeholder="Required" />
					</Form.Item>
					<Form.Item label="Start Date" name="start_date">
						<DatePicker
							placeholder="Required"
							format={"DD/MM/YYYY"}
							style={{ width: "100%" }}
						/>
					</Form.Item>
					<Form.Item label="End Date" name="end_date">
						<DatePicker
							placeholder="Required"
							format={"DD/MM/YYYY"}
							style={{ width: "100%" }}
						/>
					</Form.Item>
					<Form.Item label="Redeem Expiry Date" name="redeem_expiry_date">
						<DatePicker
							placeholder="Required"
							format={"DD/MM/YYYY"}
							style={{ width: "100%" }}
						/>
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn btn-primary">
						{spinGameId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</Fragment>
	);
};

export default SpinGameForm;
